module.exports = __webpack_public_path__ + "static/media/ar21_mdaniels.1cd4235a.jpeg";